import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { baseTheme } from '../../../theme';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
    },
    pdfImage: {
      height: '1.7em',
      marginRight: theme.spacing(1),
    },
    videoImage: {
      height: '1.7em',
      marginRight: theme.spacing(1),
    },
    title: {
      fontSize: '1.3em',
      lineHeight: '1.4',
    },
  }),
);

export interface IIntroductionLinkProps {
  name: string;
  pdfUrl: string;
  videoUrl: string;
  breakpoint: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
}

export default function InstructionLink(props: IIntroductionLinkProps) {
  const { name, pdfUrl, videoUrl, breakpoint } = props;
  const classes = useStyles(baseTheme);
  return (
    <Grid item container direction="row" xs={breakpoint} className={classes.root}>
      {!!pdfUrl &&
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
        <img src="/images/pdf.png" alt={name} className={classes.pdfImage} />
      </a>}
      <Typography className={classes.title}>{name}</Typography>
    </Grid>
  );
}
